import React, { useState, useEffect, useRef } from 'react';

function MainContainer() {
    return(
        <div>main html</div>
    );
}

export default MainContainer;

